//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            intervalsStr: null,
            errors: {
                values: false,
            },
        };
    },

    methods: {
        async validateFn(item, editItem) {
            this.errors.values = false;

            // This causes the bounce animation on fields with errors
            // to be triggered again on repeated validation
            await $.delay(0);

            this.errors.values = this.getIntervalsStrError(this.intervalsStr);

            if (!this.errors.values) {
                editItem.values = this.intervalsStrToValues(this.intervalsStr);

                return true;
            }

            return false;
        },
        getValuesFn(values) {
            if (!this.intervalsStr) {
                this.intervalsStr = $.valuesToIntervals(values).join(', ');
            }

            return this.intervalsStr;
        },
        setValuesFn(val) {
            this.intervalsStr = val;

            // Return anything to mark detail as dirty
            return [];
        },
        intervalsStrToValues(str) {
            let intervals = str.split(/, */).map(i => i.trim().split('-'));
            let values = [parseInt(intervals[0][0]) - 1];

            for (const i of intervals) {
                values.push(parseInt(i[1]));
            }

            return values;
        },
        getIntervalsStrError(str) {
            if (!str)
                return 'Nebyly definovány žádné intervaly.';

            if (/[^0-9, -]/.test(str))
                return 'Intervaly obsahují neplatné znaky.';

            const intervals = str.split(/, */).map(i => i.trim().split('-'));

            if (intervals.some(i => i.length !== 2))
                return 'Chybný formát intervalu: příliš mnoho pomlček.';

            if (intervals.some(([a, b]) => a !== `${parseInt(a)}` || b !== `${parseInt(b)}`))
                return 'Chybný formát intervalu: hodnoty nejsou přirozená čísla.';

            if (intervals.some(([a, b]) => a == 0 || b == 0))
                return 'Interval obsahuje nulu.';

            for (let i = 1; i < intervals.length; ++i)
                if (parseInt(intervals[i][0]) > parseInt(intervals[i][1]))
                    return 'Interval je klesající.';

            for (let i = 1; i < intervals.length; ++i)
                if (parseInt(intervals[i][0]) !== parseInt(intervals[i - 1][1]) + 1)
                    return 'Intervaly na sebe nenavazují.';

            return false;
        },
        onDetailInit() {
            this.errors.values = false;
            this.intervalsStr = null;
        },
    },
};
